import "./Header.css";

const Header = () => {
  return (
    <div className="header__section">
      <div className="body-image">
        <img src="/images/logo.png" alt="logo" />
      </div>
    </div>
  );
};

export default Header;
